import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { BreadcrumbItem, BreadcrumbsState } from './types'

const initialState: BreadcrumbsState = {}

const BreadcrumbsSlice = createSlice({
  name: 'breadcrumbs',
  initialState,
  reducers: {
    setBreadcrumb: (state, { payload }: PayloadAction<BreadcrumbItem>) => {
      state[payload.key] = payload.label
    },
  },
})

export const { setBreadcrumb } = BreadcrumbsSlice.actions
export const breadcrumbsSlice = BreadcrumbsSlice.reducer
